export default __webpack_public_path__ + "static/media/jackpot1.c2848f64.png";